<template>
  <v-card class="rounded-card card-shadow">
    <v-card-text>
      <v-row dense>
        <v-col cols="12" :sm="isEmEdicao ? '10' : '7'">
          <p class="mb-1">
            <v-chip label class="mb-2" v-if="finalizacao.codigoInterno">
              <px-span-tooltip
                bottom
                :text="finalizacao.codigoInterno"
                tooltip="Número da OC"/>
            </v-chip>
            <span class="headline text--primary">
              {{ finalizacao.comprador.pessoa.nome }}
              <px-popover-comprador :comprador="finalizacao.comprador"/>
            </span>
            <px-situacao-compra-tag :situacao="finalizacao.situacao"
                                    comprador-color="blue lighten-1"
                                    fornecedor-color="amber darken-1"/>
            <v-chip color="secondary" label v-if="isCatalogo">
              Catálogo
            </v-chip>
          </p>
        </v-col>
        <v-col cols="12" :sm="isEmEdicao ? '2' : '5'" class="text-right">
          <template v-if="isPendenteFornecedor">
            <px-finalizacao-recusar-dialog :compra-id="compraId"
                                           :compra="finalizacao"
                                           @movimentar="onMovimentar"/>
            <px-finalizacao-aprovar-dialog :compra-id="compraId"
                                           :compra="finalizacao"
                                           v-if="!isCotacaoConjunta && isAprovacaoEnabled"
                                           @movimentar="onMovimentar"/>
            <px-finalizacao-confirm-approve-dialog
              :request-id="compraId"
              v-if="!isCotacaoConjunta && !isAprovacaoEnabled"
              :name="finalizacao.comprador.pessoa.nome"
              @update="onMovimentar"
            />
            <px-venda-conjunta-aprovar-pedido :venda="finalizacao"
                                              :icon="false"
                                              color="primary"
                                              v-if="isCotacaoConjunta"
                                              @update="onMovimentar"/>
          </template>
          <px-detalhes-finalizacao-print-pdf :venda="finalizacao"/>
        </v-col>
      </v-row>
      <p class="mt-2">
        <v-icon>mdi-shopping-outline</v-icon>
        Número do pedido Proxpect - {{ finalizacao.id }}
      </p>
      <p class="mt-2">
        <v-icon>mdi-domain</v-icon>
        {{ finalizacao.comprador.pessoa.cnpj | cnpj }}
      </p>
      <p>
        <v-tooltip bottom>
          <template v-slot:activator="{ on }">
            <span v-on="on">
              <v-icon>mdi-map-marker</v-icon>
              {{ finalizacao.compradorEntrega.endereco | endereco }}
            </span>
          </template>
          <span>Endereço de entrega</span>
        </v-tooltip>
      </p>
      <div class="text--primary">
        <v-row dense>
          <v-col cols="12" sm="3">
            <span class="caption font-weight-bold">Forma de pagamento</span>
            <div>
              <px-forma-pagamento :forma-pagamento="finalizacao.formaPagamento"
                                  :prazo-pagamento="finalizacao.prazoPagamento"/>
            </div>
          </v-col>
          <v-col cols="12" sm="3">
            <span class="caption font-weight-bold">Tipo de frete</span>
            <div>
              {{ finalizacao.frete.tipoFrete }}
            </div>
          </v-col>
          <v-col cols="12" sm="3" v-if="finalizacao.usuario">
            <span class="caption font-weight-bold">Comprador responsável</span>
            <div>
              {{ finalizacao.usuario.nome }}
            </div>
          </v-col>
          <v-col cols="12" sm="3">
            <span class="caption font-weight-bold">Finalidade da Compra</span>
            <div v-if="finalizacao.finalidadeCompra">
              <px-finalidade-compra-value :finalidade-compra="finalizacao.finalidadeCompra"/>
            </div>
            <div v-else>
              Não Informado
            </div>
          </v-col>
        </v-row>
        <v-row dense>
          <v-col cols="12" sm="3">
            <span class="caption font-weight-bold">Mensagem do comprador</span>
            <div>
              <px-show-large-text :large-text="finalizacao.mensagem"/>
            </div>
          </v-col>
          <v-col cols="12" sm="3">
            <span class="caption font-weight-bold">Mensagem para o comprador</span>
            <div>
              <px-show-large-text :large-text="finalizacao.mensagemFornecedor"/>
            </div>
          </v-col>
          <v-col cols="12" sm="3">
            <span class="caption font-weight-bold">Data de Faturamento</span>
            <div>
              {{ finalizacao.dataFaturamento | date | naoInformado }}
            </div>
          </v-col>
          <v-col cols="12" sm="3">
            <span class="caption font-weight-bold">Modo de pagamento</span>
            <div>
              {{ modoPagamento }}
            </div>
          </v-col>
        </v-row>
        <v-row dense>
          <v-col cols="12" sm="3" v-if="hasTransportadora">
            <span class="caption font-weight-bold">Transportadora</span>
            <div>
              {{ finalizacao.transportadora.pessoa.nome }}
            </div>
          </v-col>
          <v-col cols="12" sm="3" v-if="isRecusadoCancelado">
            <span class="caption font-weight-bold">Motivo da recusa/cancelamento</span>
            <div>
              <px-show-large-text :large-text="finalizacao.motivoRecusa"/>
            </div>
          </v-col>
          <v-col cols="12" sm="3" v-if="finalizacao.tipoNotaEntrada">
            <span class="caption font-weight-bold">Tipo de nota de entrada</span>
            <div>
              <px-span-tooltip top
                               :text="notaEntrada"
                               :tooltip="finalizacao.tipoNotaEntrada.descricao"/>
            </div></v-col>
          <v-col cols="12" sm="3" v-if="finalizacao.cfop">
            <span class="caption font-weight-bold">CFOP da compra</span>
            <div>
              <px-span-tooltip top
                               :text="cfop"
                               :tooltip="tooltipCfop"/>
            </div>
          </v-col>
        </v-row>
        <v-row dense>
          <v-col cols="12" sm="6">
            <span class="caption font-weight-bold">Nota fiscal</span>
            <div class="d-flex align-center">
              {{ labelNotaFiscal }}
              <px-anexo small
                        v-model="finalizacao.notaFiscalFile"
                        title="Nota fiscal"
                        empty-button-text="Nota fiscal"
                        :download-base-path="downloadFilePath"
                        :upload-base-path="uploadBasePath"
                        :max="1"
                        :show-badge="false"
                        @loading="onNotaFiscalLoading"
                        @remove="onRemoveNotaFiscal">
                <template v-slot:activator="{ on }">
                  <v-btn icon
                         small
                         v-on="on">
                    <v-icon small>mdi-paperclip</v-icon>
                  </v-btn>
                </template>
              </px-anexo>
            </div>
          </v-col>
          <v-col cols="12" sm="6" v-if="finalizacao.arquivos && finalizacao.arquivos.length">
            <span class="caption font-weight-bold">Anexos</span>
            <div>
              <px-anexo-chip :files="finalizacao.arquivos"
                             :download-base-path="downloadFilePath"/>
            </div>
          </v-col>
        </v-row>
        <v-row dense>
          <v-col cols="12">
            <px-responsaveis :responsaveis="finalizacao.fornecedoresReponsaveis"
                             custom-path="compras"
                             :id="finalizacao.id"
                             :id-company="finalizacao.fornecedor.id"
                             @update="onMovimentar"/>
          </v-col>
        </v-row>
      </div>
    </v-card-text>
  </v-card>
</template>

<script>
import { OrigemCompra, SituacaoCompra, TipoFrete } from 'px-business-components';
import Vue from 'vue';
import VendaConjuntaAprovarPedido from '@/modules/venda-conjunta/VendaConjuntaAprovarPedido.vue';
import DetalhesFinalizacaoPrintPdf from '@/modules/vendas/finalizacao/DetalhesFinalizacaoPrintPdf.vue';
import FinalizacaoConfirmApproveDialog from './FinalizacaoConfirmApproveDialog.vue';
import FinalizacaoAprovarDialog from './FinalizacaoAprovarDialog.vue';
import FinalizacaoRecusarDialog from './FinalizacaoRecusarDialog.vue';
import VendasService from '../vendas-service';

export default {
  props: {
    finalizacao: Object,
    compraId: String,
  },
  data() {
    return {
      loadingNotaFiscal: false,
    };
  },
  computed: {
    notaEntrada() {
      return Vue.filter('truncate')(this.finalizacao.tipoNotaEntrada.descricao, 20);
    },
    cfop() {
      return `${this.finalizacao.cfop.codigo} - ${Vue.filter('truncate')(this.finalizacao.cfop.descricao, 15)}`;
    },
    isAprovacaoEnabled() {
      return !this.finalizacao.entidadeComprador.pularAprovacaoFornecedor;
    },
    hasTransportadora() {
      return this.finalizacao.transportadora;
    },
    isPendenteFornecedor() {
      return this.finalizacao.situacao === SituacaoCompra.keys.PENDENTE_FORNECEDOR.key;
    },
    isRecusadoCancelado() {
      return this.finalizacao.situacao === SituacaoCompra.keys.RECUSADA.key
        || this.finalizacao.situacao === SituacaoCompra.keys.CANCELADA.key;
    },
    isCotacaoConjunta() {
      return this.finalizacao.origemCompra === OrigemCompra.keys.COTACAO_CONJUNTA.key
        || this.finalizacao.origemCompra === OrigemCompra.keys.CATALOGO_COMPRA_CONJUNTA.key;
    },
    isCatalogo() {
      return this.finalizacao.origemCompra === OrigemCompra.keys.CATALOGO_COMPRA_CONJUNTA.key;
    },
    isEmEdicao() {
      return this.finalizacao.situacao === SituacaoCompra.keys.AGUARDANDO_APROVACAO_INTERNA.key;
    },
    downloadFilePath() {
      return `fornecedor/compras/${this.compraId}/file`;
    },
    uploadBasePath() {
      return '/fornecedor/files';
    },
    labelFrete() {
      return this.isCif ? 'Entrega' : 'Embarque';
    },
    isCif() {
      return this.finalizacao.frete.tipoFrete === TipoFrete.keys.CIF.key;
    },
    tooltipCfop() {
      return `${this.finalizacao.cfop.codigo} - ${this.finalizacao.cfop.descricao}`;
    },
    modoPagamento() {
      return this.finalizacao.modoPagamento ? this.finalizacao.modoPagamento.descricao : 'Não informado';
    },
    labelNotaFiscal() {
      return this.finalizacao.notaFiscalFile ? 'Atualizar nota fiscal' : 'Inserir nota fiscal';
    },
  },
  methods: {
    onMovimentar() {
      this.$emit('movimentar');
    },
    onRemoveNotaFiscal() {
      this.updateNotaFiscal();
    },
    onNotaFiscalLoading(loading) {
      if (!loading) {
        this.updateNotaFiscal();
      }
    },
    updateNotaFiscal() {
      this.loadingNotaFiscal = true;
      const payload = {
        id: this.finalizacao.id,
        notaFiscalFile: this.finalizacao.notaFiscalFile[0],
      };

      const message = payload.notaFiscalFile === undefined ? 'Nota fiscal removida' : 'Nota fiscal atualizada';

      VendasService.updateNotaFiscal(this.compraId, payload)
        .then(() => {
          this.$toast(message, { color: 'success' });
        })
        .finally(() => {
          this.loadingNotaFiscal = false;
        });
    },
  },
  created() {
    this.finalizacao.notaFiscalFile = this.finalizacao.notaFiscalFile
      ? [this.finalizacao.notaFiscalFile] : [];
  },
  components: {
    pxFinalizacaoAprovarDialog: FinalizacaoAprovarDialog,
    pxFinalizacaoRecusarDialog: FinalizacaoRecusarDialog,
    pxVendaConjuntaAprovarPedido: VendaConjuntaAprovarPedido,
    pxFinalizacaoConfirmApproveDialog: FinalizacaoConfirmApproveDialog,
    pxDetalhesFinalizacaoPrintPdf: DetalhesFinalizacaoPrintPdf,
  },
};
</script>
